import {Box, Typography} from '@mui/material';
import {useState} from 'react';
import {findDOMNode} from 'react-dom';
import ReactPlayer from 'react-player';
import screenfull from 'screenfull';
import PlayButtonIcon from '@icons/PlayButtonIcon';
import {ILive} from './liveData';

interface IProps {
	live: ILive;
}

export default function LiveBox({live}: IProps) {
	const [playing, setPlaying] = useState(false);
	
	let player: any;
	const video = (p: any) => {
		player = p;
	};
	
	const handleClick = () => {
		setPlaying((current) => !current);
		if (screenfull.isEnabled) {
			try {
				screenfull.toggle(findDOMNode(player) as Element);
			} catch (e) {
				//TODO send to sentry
			}
		}
	};
	
	screenfull.on('change', event => {
		if (!screenfull.isFullscreen) {
			setPlaying(false);
		}
	});
	
	return (
		<Box onClick={handleClick} className="relative rounded overflow-hidden">
			{
				playing ?
					''
					:
					<div
						className="h-full w-full absolute">
						<Box
							className="flex flex-row rtl:space-x-reverse space-x-2 p-2 h-10 w-full top-0 absolute items-center"
							sx={{bgcolor: 'rgba(31, 31, 31, 0.7)'}}>
							<Typography className="font-medium" sx={{
								color: '#fff',
								fontSize: (theme) => theme.typography.fontSize + 2
							}}>{live.name}</Typography>
						</Box>
						<div className="center mt-5"><PlayButtonIcon/></div>
					</div>
			}
			<ReactPlayer ref={video} className="w-full h-auto" playing={playing} url={live.link}/>
		</Box>
	);
}
